import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../styles";

interface LeftSideBarIconProps {
  name: string | JSX.Element;
  isActive: boolean;
  onClick: () => void;
  icon: string;
  link: string;
  locked?: boolean;
  onLockedClick?: () => void;
}

function LeftSideBarIcon({
  name,
  icon,
  isActive,
  onClick,
  link,
  locked = false,
  onLockedClick,
}: LeftSideBarIconProps) {
  const content = (
    <Box
      display="flex"
      alignItems={"center"}
      flexDirection="column"
      sx={[
        styles.button,
        isActive ? styles.active : {},
        locked ? { opacity: 0.4, cursor: "pointer" } : {},
      ]}
      onClick={locked ? onLockedClick : onClick}
    >
      <Typography
        textAlign="center"
        gutterBottom
        sx={isActive ? styles.activeText : styles.inactiveText}
      >
        <Box
          component="i"
          className={locked ? "fa-thin fa-lock" : icon}
          sx={{ fontSize: 16 }}
        />
      </Typography>

      <Typography
        textAlign="center"
        variant="caption"
        sx={[styles.iconText, isActive ? { color: "white" } : {}]}
      >
        {name}
      </Typography>
    </Box>
  );

  if (locked) {
    return <Box sx={styles.link}>{content}</Box>;
  }

  return (
    <Link to={link} style={styles.link}>
      {content}
    </Link>
  );
}

export default LeftSideBarIcon;
